import { Component } from "react";
import { dataMain } from '../../data.js';
import { buttonPressed, noContextMenu } from '../../logic/DOMElementsRelated.js';
import { goToNftPath } from "../../logic/nftRelated.js";
import retrieveOwner from "../../logic/query.js";
import Sound from "../../logic/Sound";
import "./xopowo.css";
import { XopowoOptions } from "./XopowoOptions";
import { XopowoPadsContainer } from "./XopowoPadsContainer";
import { XopowoSoundIdentifer } from "./XopowoSoundIdentifier";

class XopowoLogic extends Component {
  constructor(props) {
    super(props)
    this.state = {
      pads: [],
      soundIdentifier: '',
      currentSndImg: '',
      soundIdentifierVisible: [false, false, false, false, false, false, false, false, false, false, false],
      loopOn: false,
      clickSoundPossible : [true, true, true, true, true, true, true, true, true],
      bpm: 600,
      imgMain: dataMain.imgSrc,
      beatOn: false,
      data: this.props.data,
      accessKeyPanel: this.props.data.accessKeyPanel,
      soundIdentifierPanel: dataMain.imgSrc[11],
      imagesSrc: this.props.data.imagesSrc,
      owner: '',
      ownerAddress: '',
      usedStats: {
        pad1: 0,
        pad2: 0,
        pad3: 0,
        pad4: 0,
        pad5: 0,
        pad6: 0,
        pad7: 0,
        pad8: 0,
        pad9: 0,
      },
      clickPossible: true,
    }
    this.handleClick = this.handleClick.bind(this)
    this.handlePointer = this.handlePointer.bind(this)
    this.keyDown = this.keyDown.bind(this)
    this.keyUp = this.keyUp.bind(this)
    this.unloadEventListener = this.unloadEventListener.bind(this)
  }

  componentDidMount() {
    this.loadContent()
    this.keyCodeListener()
    this.fetchOpenSea()
    noContextMenu()
  }

  componentWillUnmount() {
    this.state.audios.forEach(sound => {
      sound.stop()
    })
    this.unloadEventListener()
  }

  loadContent() {
    const pads = document.querySelectorAll('.pad')
    const soundIdentifier = document.querySelector(".sound-identifier")
    this.setState({pads: pads, soundIdentifier: soundIdentifier})
    this.loadSound()
    this.loadLocalStats()
  }

  loadSound() {
    const audios = []

    let bass1 = new Sound(this.state.data.audios[0], 6);
    let bass2 = new Sound(this.state.data.audios[1], 6);
    let bass3 = new Sound(this.state.data.audios[2], 6);
    let hihat = new Sound(this.state.data.audios[3], 6);
    let kick = new Sound(this.state.data.audios[4], 6);
    let snare = new Sound(this.state.data.audios[5], 6);
    let pad1 = new Sound(this.state.data.audios[6], 15);
    let pad2 = new Sound(this.state.data.audios[7], 15);
    let pad3 = new Sound(this.state.data.audios[8], 15);
    let loop = new Sound(this.state.data.audios[9], 3);
    let beat = new Sound(this.state.data.audios[10], 3)
  
    audios.push(pad1)
    audios.push(pad2)
    audios.push(pad3)
    audios.push(bass1)
    audios.push(bass2)
    audios.push(bass3)
    audios.push(kick)
    audios.push(snare)
    audios.push(hihat)
    audios.push(loop)
    audios.push(beat)

    this.setState({audios: audios})
  }

  keyCodeListener() {
    document.addEventListener('keyup', this.keyUp)

    document.addEventListener('keydown', this.keyDown)
  }

  keyUp(event) {
    switch(event.code) {
      case "Numpad1": case "KeyZ":
        this.reactivateAction(0)
        break
      
      case "Numpad2": case "KeyX":
        this.reactivateAction(1)
        break

      case "Numpad3": case "KeyC":
        this.reactivateAction(2)
        break

      case "Numpad4": case "KeyA":
        this.reactivateAction(3)
        break

      case "Numpad5": case "KeyS":
        this.reactivateAction(4)
        break

      case "Numpad6": case "KeyD":
        this.reactivateAction(5)
        break

      case "Numpad7": case "KeyQ":
        this.reactivateAction(6)
        break

      case "Numpad8": case "KeyW":
        this.reactivateAction(7)
        break

      case "Numpad9": case "KeyE":
        this.reactivateAction(8)
        break

      default: break
    }
  }

  keyDown(event) {
    switch(event.code) {
      case "Numpad1": case "KeyZ":
        this.actionLimiter(0, 6)
        break
      
      case "Numpad2": case "KeyX":
        this.actionLimiter(1, 7)
        break

      case "Numpad3": case "KeyC":
        this.actionLimiter(2, 8)
        break

      case "Numpad4": case "KeyA":
        this.actionLimiter(3, 3)
        break

      case "Numpad5": case "KeyS":
        this.actionLimiter(4, 4)
        break

      case "Numpad6": case "KeyD":
        this.actionLimiter(5, 5)
        break

      case "Numpad7": case "KeyQ":
        this.actionLimiter(6, 0)
        break

      case "Numpad8": case "KeyW":
        this.actionLimiter(7, 1)
        break

      case "Numpad9": case "KeyE":
        this.actionLimiter(8, 2)
        break

      case "KeyV":
        this.loopPressed(document.getElementById('loopContainer'))
        break
      
        case "KeyF":
        this.beatPressed(document.getElementById('beatContainer'))
        break

      case "KeyB":
        this.refreshPressed(document.getElementById('refreshContainer'))
        break

      case "KeyN":
        this.ownershipPressed(document.getElementById('ownershipLink'))
        break

      default: break
    }
  }

  unloadEventListener() {
    window.removeEventListener('keyup', this.keyUp)
    window.removeEventListener('keydown', this.keyDown)
  }

  handlePointer(event) {
    const clickPossible = false
    this.setState({clickPossible: clickPossible}, () => {
      switch(event.target.parentElement.dataset.id) {
        case "pad": 
          this.action(event.target.parentElement)
          break
  
        default: break
      } 
      setTimeout(() => {
        const clickPossible = true
        this.setState({clickPossible: clickPossible}, () => {
        })
      }, this.state.bpm)
    })
  } 

  async fetchOpenSea() {
    const result = await retrieveOwner(this.state.data.contractAdress, this.state.data.tokenId)
    const owner = result.top_ownerships[0].owner.user.username
    const ownerAddress = result.top_ownerships[0].owner.address
    this.setState({owner: owner, ownerAddress: ownerAddress})
  }

  actionLimiter(clickSoundIndex, padsIndex) { 
    if (this.state.clickSoundPossible[clickSoundIndex]) {
      const clickSoundPossible = [...this.state.clickSoundPossible]
      clickSoundPossible[clickSoundIndex] = false
      this.setState({clickSoundPossible: clickSoundPossible}, () => {
        this.action(this.state.pads[padsIndex])
        setTimeout(() => {
          const clickSoundPossible = [...this.state.clickSoundPossible]
          clickSoundPossible[clickSoundIndex] = true
          this.setState({clickSoundPossible: clickSoundPossible})
        }, this.state.bpm)
      })
    }
  }

  reactivateAction(clickSoundIndex) {
    const clickSoundPossible = [...this.state.clickSoundPossible]
    clickSoundPossible[clickSoundIndex] = true
    this.setState({clickSoundPossible: clickSoundPossible})
  }

  handleClick(event) {
    if (this.state.clickPossible) {
      switch(event.target.parentElement.dataset.id) {
        case "pad": 
          this.action(event.target.parentElement)
          break
        
        case "playLoop-btn":
          this.loopPressed(document.getElementById('loopContainer'))
          break
  
        case "playBeat-btn":
          this.beatPressed(document.getElementById('beatContainer'))
          break
  
        case "refresh-btn":
          this.refreshPressed(document.getElementById('refreshContainer'))
          break
        
        case "ownership-btn":
          this.ownershipPressed(document.getElementById('ownershipLink'))
          break
        default: break
      }
    }
  }

  action(padEl) {
    buttonPressed(padEl.children)
    setTimeout(() => buttonPressed(padEl.children), 175)

    if (!this.state.loopOn && !this.state.beatOn) this.setSoundIdentifier(padEl.id)
    else this.quickSoundIdentifier(padEl.id)

    this.playSound(padEl.id)
  }

  loopPressed(parent) {
    this.playLoop()
    buttonPressed(parent.children)
    this.updateButtonToOff(parent.previousElementSibling.children)
  }

  beatPressed(parent) {
    this.playBeat()
    buttonPressed(parent.children)
    this.updateButtonToOff(parent.nextElementSibling.children)
  }

  refreshPressed(parent) {
    buttonPressed(parent.children)
    setTimeout(() => {
      buttonPressed(parent.children)
      window.location.reload()
    }, 175)
  }

  ownershipPressed(parent) {
    buttonPressed(parent.children)
    setTimeout(() => {
      buttonPressed(parent.children)
      // console.log(parent)
      goToNftPath(parent.dataset.href)
    }, 175)
  }

  updateButtonToOff(children) {
    children[0].classList.remove('visible')
    children[0].classList.add('hidden')
    children[1].classList.add('visible')
    children[1].classList.remove('hidden')
  }
  
  setSoundIdentifier(padId) {
    const idImgToSwitch = this.identifySoundImg(padId)
    
    this.hideSndImg()
    this.findSndImg(idImgToSwitch)
  }

  quickSoundIdentifier(padId) {
    const idImgToSwitch = this.identifySoundImg(padId)
    this.hideSndImg()
    this.findSndImg(idImgToSwitch)
    setTimeout(() => {
      this.hideSndImg()
      if (this.state.loopOn) {
        this.findSndImg("sndIdn10")
      }
      else {
        this.findSndImg("sndIdn11")
      }
    },350)
  }

  identifySoundImg(padId) {
    switch(padId) {
      case 'pad1':
        return "sndIdn1"

      case 'pad2':
        return "sndIdn2"

      case 'pad3':
        return "sndIdn3"

      case 'pad4':
        return "sndIdn4"

      case 'pad5':
        return "sndIdn5"

      case 'pad6':
        return "sndIdn6"

      case 'pad7':
        return "sndIdn7"

      case 'pad8':
        return "sndIdn9"

      case 'pad9':
        return "sndIdn8"

      default: break
    }
  }

  hideSndImg() {
    const soundIdentifierVisible = [false, false, false, false, false, false, false, false, false, false, false]   
    this.setState({soundIdentifierVisible: soundIdentifierVisible})
  }

  findSndImg(idImgToSwitch) {
    const children = this.state.soundIdentifier.children
    this.setState({currentSndImg: idImgToSwitch}, () => {
      for (let i = 0; i < children.length; i++) {
        if (children[i].id === this.state.currentSndImg)  
          this.showSndImg(i) 
      }
    })
  }

  showSndImg(index) {
    let soundIdentifierVisible = [...this.state.soundIdentifierVisible]
    soundIdentifierVisible[index] = !soundIdentifierVisible[index]
    this.setState({soundIdentifierVisible: soundIdentifierVisible})
  }

  playLoop() {
    const loopOn = this.state.loopOn ? false : true
    this.setState({loopOn: loopOn, beatOn: false}, () => {
      if (this.state.loopOn) {
        this.hideSndImg()
        this.findSndImg("sndIdn10")
        this.state.audios[10].fadeOut()
        this.state.audios[9].fadeIn()
      }
      else {
        this.hideSndImg()
        this.state.audios[9].fadeOut()
      }
    })
  }

  playBeat() {
    const beatOn = this.state.beatOn ? false : true
    this.setState({beatOn: beatOn, loopOn: false}, () => {
      if (this.state.beatOn) {
        this.hideSndImg()
        this.findSndImg("sndIdn11")
        this.state.audios[9].fadeOut()
        this.state.audios[10].fadeIn()
      }
      else {
        this.hideSndImg()
        this.state.audios[10].fadeOut()
      }
    })
  }
  
  playSound(id) {
    switch (id) {
      case 'pad1':
        this.state.audios[0].stop()
        this.state.audios[1].stop()
        this.state.audios[2].stop()
        this.state.audios[0].play()
        this.countUp('pad1')
        break

      case 'pad2':
        this.state.audios[0].stop()
        this.state.audios[1].stop()
        this.state.audios[2].stop()
        this.state.audios[1].play()
        this.countUp('pad2')
        break

      case 'pad3':
        this.state.audios[0].stop()
        this.state.audios[1].stop()
        this.state.audios[2].stop()
        this.state.audios[2].play()
        this.countUp('pad3')
        break

      case 'pad4':
        this.state.audios[3].stop()
        this.state.audios[4].stop()
        this.state.audios[5].stop()
        this.state.audios[3].play()
        this.countUp('pad4')
        break

      case 'pad5':
        this.state.audios[3].stop()
        this.state.audios[4].stop()
        this.state.audios[5].stop()
        this.state.audios[4].play()
        this.countUp('pad5')
        break

      case 'pad6':
        this.state.audios[3].stop()
        this.state.audios[4].stop()
        this.state.audios[5].stop()
        this.state.audios[5].play()
        this.countUp('pad6')
        break

      case 'pad7':
        this.state.audios[6].stop()
        this.state.audios[6].play()
        this.countUp('pad7')
        break

      case 'pad8':
        this.state.audios[7].stop()
        this.state.audios[7].play()
        this.countUp('pad8')
        break

      case 'pad9':
        this.state.audios[8].stop()
        this.state.audios[8].play()
        this.countUp('pad9')
        break

      default: break
    }
  }

  countUp(padToAdd) {
    const usedStats = this.state.usedStats

    switch(padToAdd) {
      case "pad1":
        usedStats.pad1 += 1
        break

      case "pad2":
        usedStats.pad2 += 1
        break
        
      case "pad3":
        usedStats.pad3 += 1
        break
        
      case "pad4":
        usedStats.pad4 += 1
        break
        
      case "pad5":
        usedStats.pad5 += 1
        break
        
      case "pad6":
        usedStats.pad6 += 1
        break
        
      case "pad7":
        usedStats.pad7 += 1
        break

      case "pad8":
        usedStats.pad8 += 1
        break

      case "pad9":
        usedStats.pad9 += 1
        break

      default: 
        break
    }

    this.props.updateUsedStats(usedStats)

    this.saveStats()
  }

  loadLocalStats() {
    const model = this.props.data.model
    const edition = this.props.data.edition
    const dataToLoad = `${model}.${edition}`

    const localDataLoaded = localStorage.getItem(dataToLoad)

    const data = JSON.parse(localDataLoaded)

    // console.log(data)
    
    if (localDataLoaded !== null) {
      this.setState({usedStats: data})
    }
  }

  saveStats() {
    const model = this.props.data.model
    const edition = this.props.data.edition
    const dataToSave = `${model}.${edition}`

    const stats = this.state.usedStats

    localStorage.setItem(dataToSave, JSON.stringify(stats))
  }

  render() {
    return (
      <div id="container-MPT" style={{height: this.props.height, width: this.props.width}}>
        <img draggable="false" className="noContextMenu" id="xopowoFrameImg" src={this.state.imagesSrc[2]} alt="MPT Template" />           
        <XopowoPadsContainer handleClick={this.handleClick} imgSrc={this.state.imagesSrc} handlePointer={this.handlePointer}/>
        <XopowoSoundIdentifer visible={this.state.soundIdentifierVisible} imgSrc={this.state.imagesSrc} />
        <XopowoOptions handleClick={this.handleClick} imgSrc={this.state.imagesSrc} path={this.state.data.nftPath} />
      </div> 
    )
  }
}

export default XopowoLogic